<template>
  <div class="page-container categories-list" v-if="attribute">
    <div class="page-title-container">
      <h1 class="page-title">Atributo: {{ attribute.name }}</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData(attributeId)"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData(attributeId)"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por descripción"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'config-attributes-create-value' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Usuario</span>
            </div>
            <div>
              <span>Estado</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.name }}</span>
                </div>

                <div>
                  <span :class="`badge ${getStatus(o.isActive).color}`">{{
                  getStatus(o.isActive).label
                }}</span>
                </div>

                <!-- <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div> -->
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'config-attributes-edit-value', params: { attributeId: attribute.id, valueId: o.id } }"
                >
                  Editar
                </router-link>

                <a
                  href=""
                  class="ml-2"
                  :class="{
                    'text-danger': getStatus(o.isActive).action === 'Suspender',
                  }"
                  @click.prevent="openChangeStatus(o)"
                  >{{ getStatus(o.isActive).action }}</a
                >

                <a href="" class="ml-2" @click.prevent="openDelete(o)">Eliminar</a>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Estado</th>
              <th>Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="text-center">
                {{ o.name }}
              </td>
              <td class="text-center">
                <span :class="`badge ${getStatus(o.isActive).color}`">{{
                  getStatus(o.isActive).label
                }}</span>
              </td>

              <td class="text-center d_option">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem :to="{ name: 'config-attributes-edit-value', params: { attributeId: attribute.id, valueId: o.id } }" text="Editar"
                    />
                    <DropdownItem
                      :text="getStatus(o.isActive).action"
                      @click="openChangeStatus(o)"
                    />
                    <DropdownItem text="Eliminar" @click="openDelete(o)" />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ConfirmationModal
      :show="confirmationModal.show"
      @hide="closeConfirmationModal"
      :data="confirmationModal"
      @confirm="confirmModal"
    />
  </div>
</template>

<script>
import {
  Alert,
  Constants,
  Util,
  ConfirmationModalMixin,
  PaginationMixin,
  FilterMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
  ConfirmationModal,
  FilterMenu
} from "@wizepe/wize-admin";

import { Constants as LocalConstants } from "@/core/utils";

import { AttributeService } from "@/core/services";

export default {
  components: {
    SearchBar,
    FilterMenu,
    ConfirmationModal,
    DropdownTable,
    DropdownItem
  },
  mixins: [PaginationMixin, ConfirmationModalMixin, FilterMixin],
  data() {
    return {
      attributeId: this.$route.params.attributeId,
      attribute: null,
      list: [],
      tooltipType: null,
      selectedOption: null,
      filterOptions: [
        {
          label: "Estado",
          key: "isActive",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.ProductsAttributesStatus.ACTIVE,
            LocalConstants.ProductsAttributesStatus.INACTIVE,
          ],
        },
      ],
    };
  },
  watch: {
    "$route.params.attributeId": function () {
      if (this.$route.params.attributeId) {
        this.attributeId = this.$route.params.attributeId;
        this.loadData(this.attributeId);
      }
    },
  },
  methods: {
    async loadData(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await AttributeService.get(id);
        this.attribute = { ...response.payload };
        this.applyFilters();
      } catch (e) {
        console.error(e);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    getAttributeType(key) {
      return Util.searchValue(key, LocalConstants.ProductsAttributes);
    },
    getStatus(key) {
      return Util.searchValue(key, LocalConstants.ProductsAttributesStatus);
    },
    confirmModal() {
      this.closeConfirmationModal();
      if (this.confirmationModal.action === "delete") this.deleteObject();
      else if (this.confirmationModal.action === "update") this.changeStatus();
    },
    async changeStatus() {
      try {
        await this.$store.dispatch("app/loading", true);
        const resp = (
          await AttributeService.updateAttributeValueStatus(
            this.attributeId,
            this.selectedOption.id,
            !this.selectedOption.isActive
          )
        ).payload;

        const value = this.list.find((o) => {
          return o.id === resp.id;
        });

        if (value) {
          const index = this.list.indexOf(value);
          this.$set(this.list, index, resp);
        }
        Alert.success("Estado actualizado correctamente");
        this.$store.commit('app/setAttributes', null)
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    openChangeStatus(o) {
      this.selectedOption = o;
      this.openConfirmationModal({
        title: "Cambiar estado",
        description: "¿Está seguro que desea cambiar el estado del valor?",
        acceptText: "Aceptar",
        action: "update",
      });
    },
    openDelete(o) {
      this.selectedOption = o;
      this.openConfirmationModal({ acceptText: "Borrar", action: "delete" });
    },
    async deleteObject() {
      try {
        await this.$store.dispatch("app/loading", true);
        await AttributeService.deleteAttributeValue(
          this.attributeId,
          this.selectedOption.id
        );

        await this.loadData(this.attributeId);
        this.$store.commit('app/setAttributes', null)
      } catch (ex) {
        console.error(ex);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    setFilters(options) {
      this.showFilters = false;
      this.filters = { ...options };
      this.applyFilters();
    },
    deleteFilter(label) {
      delete this.filters[label];
      this.filters = { ...this.filters };

      this.loadData(this.$route.params.attributeId);
    },
    onSearch(keyword) {
      this.search = keyword;
      this.applyFilters();
    },
    // Búsqueda sin distinguir mayúsculas ni tildes, combinada con el filtro de estado
    applyFilters() {
      if (!this.attribute) return;
      const normalize = (text) =>
        (text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
      const term = normalize(this.search);
      this.list = this.attribute.values.filter(
        (item) =>
          (this.filters.isActive === undefined || item.isActive === this.filters.isActive) &&
          (!term || normalize(item.name).includes(term))
      );
    },
  },
  computed: {
    showFiltersList() {
      return Object.keys(this.filters).length >= 1;
    },
  },
  async mounted() {
    if (this.$route.params.attributeId)
      this.loadData(this.$route.params.attributeId);
  },
};
</script>

<style lang="stylus" scoped>
@import "~@wizepe/wize-admin/dist/styles/variables"
.back-button
  &:hover
    background-color: white
    color: rgba(color-dark, .85)
</style>
